<template>
  <section>
    <div class="row mb-4">
      <!-- <button :class="['btn', 'btn-secondary', { 'active': 'phone' == cl }]" @click="setRT('phone')">
        <i class="fas fa-phone icon"></i>
      </button> -->

      <button :class="['btn', 'btn-secondary', { 'active': 'tables' == cl }]">
        <i class="fas fa-table icon"></i>
      </button>

      <!-- <button :class="['btn', 'btn-secondary', { 'active': 'toggle' == cl }]" @click="setRT('toggle')">
        <i class="fas fa-reply icon"></i>
      </button> -->
    </div>

    <!-- <div class="row" v-show="toggleRealtime">
      <realtime-phone :conSocket="connection" :class="[{ 'toggle-el': !toggleRealtime }]" />
    </div> -->

    <div class="row" v-show="!toggleRealtime">
      <RtmCallDetailsTable :conSocket="connection"></RtmCallDetailsTable>
      <RtmUsersDetailsTable :conSocket="connection"></RtmUsersDetailsTable>
      <br>
      <div class="col-md-12 tab-one-wrapper">
        <div class="card-status-center">
            <Group :queues="queues" @selection-changed="updateChartFilter" />
        </div>
      </div>
      <ServiceLevelRealtime :filter="chartFilter"></ServiceLevelRealtime>
    </div>
  </section>
    
</template>

<script>
// import RealtimePhone from "./RealtimePhone.vue";
import RtmCallDetailsTable from "./components/RealtimeCallDetailsTable.vue";
import RtmUsersDetailsTable from "./components/RealtimeUsersDetailsTable.vue";
import ServiceLevelRealtime from "../charts/ServiceLevelRealtime.vue";
import Group from '../filters/Group.vue';
const parsedTelefone = (process.env.MIX_TELEFONE === 'true');

export default {
  name: "RealtimeApp",
  components: {
    // RealtimePhone,
    RtmCallDetailsTable,
    RtmUsersDetailsTable,
    ServiceLevelRealtime,
    Group
  },
  data() {
    return {
      toggleRealtime: false,
      intervalId: "",
      cl: "phone",
      chartFilter: "*",
      connection: {
        on: () => { },
        emit: () => { }
      },
      queues: []
    };
  },
  created() {
    this.setupSocketConnection();
    // if (this.cl == "toggle") {
    //   this.intervalId = setInterval(() => {
    //     this.toggleRealtime = !this.toggleRealtime;
    //   }, 15000);
    // }
    this.fetchQueuesAndGroups();
  },
  mounted() {
    this.connection.emit('QueueStatus');
    setInterval(() => {
      setTimeout(async () => {
        this.connection = {
          on: function() {},
          emit: function() {}
        };
        this.setupSocketConnection();
        this.connection.emit('QueueStatus');
      }, 1000)
    }, 300000); //5 MINUTOS
  },
  methods: {
    setupSocketConnection() {
      const parsedTelefone = (process.env.MIX_TELEFONE === 'true');
      if (parsedTelefone) {
        // Limpa qualquer conexão e listeners existentes
        if (this.connection && this.connection.connected) {
          this.connection.removeAllListeners();
          this.connection.disconnect();
        }
        this.connection = io.connect(`${location.protocol}//${location.hostname}:3007/realtimeModule`, {
          reconnection: true,
          reconnectionDelay: 2000,
          reconnectionDelayMax: 10000,
          randomizationFactor: 0.5,
          pingTimeout: 600000,
          pingInterval: 120000
        });
    
        this.connection.on('connect', () => {
          console.info('Conectado ao serviço do realtime');
          this.connection.emit('QueueStatus');
        });
    
        this.connection.on('disconnect', (reason) => {
          console.info(`Desconectado: ${reason}`);
        });
    
        this.connection.on('reconnect_attempt', (attemptNumber) => {
          console.info(`Tentativa de reconexão #${attemptNumber}`);
        });
      } else {
        this.connection = {
          on: function() {},
          emit: function() {}
        };
      }
    },
    // setRT(style) {
    //   this.cl = style;
    //   clearInterval(this.intervalId);

    //   if (style == "phone") {
    //     return (this.toggleRealtime = true);
    //   }

    //   if (style == "tables") {
    //     return (this.toggleRealtime = false);
    //   }

    //   if (style == "toggle") {
    //     this.intervalId = setInterval(() => {
    //       this.toggleRealtime = !this.toggleRealtime;
    //     }, 15000);
    //   }
    // },

    fetchQueuesAndGroups() {
        axios.get('/user/listQueueUser').then(({ data }) => {
          this.queues = data;
        });
      },
      updateChartFilter(newFilter) {
        this.chartFilter = newFilter;
      }
  },
};
</script>

<style scoped>
.toggle-el {
  display: none;
}

.container-align {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.card-status-center{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
}
</style>